 <wiz-vgroup horizontalAlign="center" verticalAlign="center" width="100%" height="100%"> 
  
  <gridster #meGridster [options]="options" width="100%" height="100%" style="background: unset;">
        <gridster-item [item]="item" class="window" *ngFor="let item of tabWidgets" >
          <widget-comp
            [model]="model"
            [templatingMode]="false"
            [itemParent]="null"
            [gridsterConfig]="getRealVOFromGridsterLimitation(item)"
            [dataEnable]="false"
            [configureEnable]="false"
            [trashEnable]="false"
          ></widget-comp>
        </gridster-item>
      </gridster>

 </wiz-vgroup>
 
